export type ProofLevel = {
  id: string;
  titleKey: string;
  labelKey: string;
  textKey: string;
  points: string[];
};

export const proofLevels: ProofLevel[] = [
  {
    id: 'basic',
    titleKey: 'levels.basic.title',
    labelKey: 'levels.basic.label',
    textKey: 'levels.basic.text',
    points: [
      'levels.basic.point.photo',
      'levels.basic.point.package',
      'levels.basic.point.signatures',
      'levels.basic.point.time',
      'levels.basic.point.local',
    ],
  },
  {
    id: 'server',
    titleKey: 'levels.server.title',
    labelKey: 'levels.server.label',
    textKey: 'levels.server.text',
    points: [
      'levels.server.point.basic',
      'levels.server.point.receipt',
      'levels.server.point.public',
      'levels.server.point.app',
      'levels.server.point.share',
    ],
  },
];
